import { render } from "./WorkflowSettings.vue?vue&type=template&id=b6af6ba2&scoped=true"
import script from "./WorkflowSettings.vue?vue&type=script&lang=js"
export * from "./WorkflowSettings.vue?vue&type=script&lang=js"

import "./WorkflowSettings.vue?vue&type=style&index=0&id=b6af6ba2&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6af6ba2"]])

export default __exports__